import { Modal, Select } from "antd";

const SelectRangeModal = ({
  isOpen,
  onCancel,
  title = "Select Locker",
  selectedLockerNumber, 
  setselectedLockerNumber,
  lockerDetails,
  assignLockerToOrder,
  assignedLocker
}) => {

  return (
  <Modal
    title={title}
    centered
    open={isOpen}
    onCancel={onCancel}
    onOk={() => assignLockerToOrder(selectedLockerNumber)}
    width={400}
  >
    <Select
      className="w-full"
      placeholder={assignedLocker ? `Locker Number - ${assignedLocker}` : "Choose a locker number"}
      value={selectedLockerNumber}
      onChange={(value) => setselectedLockerNumber(value)}
    >
    {Array.isArray(lockerDetails?.range) &&
      lockerDetails.range
      .sort((a, b) => a - b)
      .map((num) => (
        <Select.Option
            key={`${lockerDetails.deviceCode}-${num}`}
            value={num}
        >
            Locker Number - {num}
        </Select.Option>
    ))}
    </Select>
  </Modal>
);

};

export default SelectRangeModal;